<template>
  <div class="tableCom">
    <div class="tableTitle">
      <span class="col-lg-5 col-md-5 col-xs-8 col-sm-8">标题</span>
      <span class="col-lg-3 col-md-3 col-xs-4 col-sm-4">
        <span class="hidden-lg hidden-md">消息来源</span>
        <div class="dropdown hidden-xs hidden-sm">
          <a id="sourceMenu" data-toggle="dropdown" aria-haspopup="true" aria-expanded="true">
            <span v-html="sourceText"></span>
            <span class="sourceIcon"></span>
          </a>
          <ul class="dropdown-menu" aria-labelledby="sourceMenu">
            <li><a href="#" @click="search('',messageType)">全部</a></li>
            <li><a href="#" @click="search('RECRUITING_PLATFORM',messageType)">采招系统</a></li>
            <li><a href="#" @click="search('JICHAI_MALL',messageType)">集采商城</a></li>
            <li><a href="#" @click="search('Order_Coordination',messageType)">订单协同</a></li>
            <li><a href="#" @click="search('Basic_Application',messageType)">基础应用</a></li>
            <li><a href="#" @click="search('SRM',messageType)">供应商管理</a></li>
            <li><a href="#" @click="search('CONTRACT',messageType)">合同管理</a></li>
            <li><a href="#" @click="search('REQUIREMENT',messageType)">需求管理</a></li>
            <div class="menuArrow"></div>
          </ul>
        </div>
      </span>
      <span class="col-lg-3 col-md-3 hidden-xs hidden-sm">
        <a class="timeSort">时间<span class="sortIcon"></span></a>
      </span>
      <span class="col-lg-1 col-md-1 hidden-xs hidden-sm">操作</span>
    </div>
    <div class="tableCon">
      <a class="tableTr clearfix" v-for="(item,index) in messageData" :key="index" @click.stop.prevent="clickFn(item.id,item.content,item.createTime,item.title,messageType,item.url,item)">
        <span @click.stop.prevent="clickFn(item.id,item.content,item.createTime,item.title,messageType,item.url,item)" class="col-lg-5 col-md-5 col-xs-8 col-sm-8">
          <i class="alreadyRead" v-if="item.isRead ==1"></i>
          <i class="unread" v-if="item.isRead ==0"></i>{{item.title}}
        </span>
        <!--<i class="alreadyRead"></i> 已读 unread未读 -->
        <span @click.stop.prevent="clickFn(item.id,item.content,item.createTime,item.title,messageType,item.url,item)" class="col-lg-3 col-md-3 col-xs-4 col-sm-4" >{{item.productLine}}</span>
        <span class="col-lg-3 col-md-3 hidden-xs hidden-sm">{{item.createTime|time}}</span>
        <span class="col-lg-1 col-md-1 hidden-xs hidden-sm">
          <a v-if="messageType == 2" @click.stop.prevent="clickViewFn(item.id,item.content,item.createTime,item.title,messageType,item)">查看</a>
          <a v-if="messageType != 2" @click.stop.prevent="clickViewFn(item.id,item.url,'','',messageType,item)">查看</a>
        </span>
      </a>
    </div>
    <el-dialog
      custom-class="realEstate"
      title="提示"
      :visible.sync="centerDialogVisible">
      <p>您即将进入地产系统，为确保功能正常使用，请使用IE10及以上版本浏览器，并设置兼容性</p>
      <!--<p><a href="javascript:;" @click="ieDown">IE10兼容性设置方法.docx</a></p>-->
      <p><a href="https://fosun-upload-prod.oss-cn-hangzhou.aliyuncs.com/%E5%A4%8D%E6%98%9F%E5%9C%B0%E4%BA%A7%E7%B1%BB%E9%A1%B9%E7%9B%AEIE%E6%B5%8F%E8%A7%88%E5%99%A8%E5%85%BC%E5%AE%B9%E6%80%A7%E8%AE%BE%E7%BD%AE.docx">IE10兼容性设置方法.docx</a></p>
      <span slot="footer" class="dialog-footer clearfix">
        <el-checkbox v-model="noMorePrompts">今天不再提示</el-checkbox>
        <el-button type="primary" @click="centerDialogFn">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import { mapState } from 'vuex'
import Cookies from 'js-cookie'
export default {
  props: ['messageData','messageType','sourceText'],
  data () {
    return {
      toDoTotal:0,
      noticeTotal:0,
      alreadyDoTotal:0,
      toDoMessageData:[],
      noticeMessageData:[],
      alreadyMessageData:[],
      refSysId:'',
      centerDialogVisible:false,
      noMorePrompts:false,
      messageId:'',
      messageUrl:'',
      messageTime:'',
      messageTitle:'',
      messageType:'',
      messageInfo:'',
      messageContent:''
    }
  },
  computed: mapState([
    'KP'
  ]),
  created () {
    if(this.getToken('isLogin') == 100){
      this.refSysId = this.getDAesString(this.getToken('refSysId'),this.KP.key,this.KP.iv)
    }
  },
  methods: {
    clickFn(id,content,time,title,messageType,messageUrl,message){
      this.messageId = id,
      this.messageContent = content;
      this.messageTime = time;
      this.messageTitle = title;
      this.messageType = messageType;
      this.messageUrl = messageUrl;
      this.messageInfo = message;
      if(message.productLine == "-" && this.getCookie('TODAY_NO_MORE_REMINDER') == 0){
        this.centerDialogVisible = true;
      }else{
        this.mobileClick(this.messageId,this.messageContent,this.messageTime, this.messageTitle,
          this.messageType,this.messageUrl,this.messageInfo)
      }
    },
    async clickViewFn(id,messageUrl,time,title,messageType,message){
      try {
        await this.$store.dispatch('findWebDtoHandler');
      } catch (e) {}

      this.messageId = id,
        this.messageUrl = messageUrl;
      this.messageTime = time;
      this.messageTitle = title;
      this.messageType = messageType;
      this.messageInfo = message;
      if(message.productLine == "-" && this.getCookie('TODAY_NO_MORE_REMINDER') == 0){
        this.centerDialogVisible = true;
      }else{
        this.viewMessage(this.messageId,this.messageUrl,this.messageTime,this.messageTitle,
          this.messageType,this.messageInfo)
      }
    },
    viewMessage(id,messageUrl,time,title,messageType,message){
      if(this.getToken('examineStatus') == '200'){
        this.$router.push({path:"registerExamine",query:{email:this.userInfo.email,companyId:this.userInfo.companyId,companyName:this.userInfo.companyName,orgIdentity:this.userInfo.orgIdentity,regAddrType:this.userInfo.regAddrType,trueName:this.userInfo.trueName}});
      }else if(this.getToken('examineStatus') == '300'){
        this.$router.push({path:"registerFailed",query:{userId:this.userInfo.id,email:this.userInfo.email,companyId:this.userInfo.companyId,companyName:this.userInfo.companyName,orgIdentity:this.userInfo.orgIdentity,regAddrType:this.userInfo.regAddrType,regeisterType:this.getToken('regeisterType'),exmaineMessage:this.getToken('exmaineMessage'),createUserId:this.userInfo.createUserId}});
      }
      else if(this.getCookie("COMPANY_COMPLETE_STATUS_"+this.getCookie("justId")) == "1"){
        this.$alert('<p>企业变更信息已提交，请耐心等待审核结果</p>', '', {
            dangerouslyUseHTMLString: true,
            customClass:'mobileText',
            center: true,
            showClose:false
          });
      }else if(this.getToken('checkFlag') == 200 && this.getCookie('TALK_LATER_'+this.getCookie('justId'))>=14){
        this.$confirm('请立即完善企业信息', '您的企业信息不完整，无法进入项目。', {
          cancelButtonClass:'cancelBtn',
          customClass:'mobileText',
          cancelButtonText: '以后再说',
          confirmButtonText: '点我补全',
          center: true
        }).then(() => {
          this.$router.push({path:'/inforPerfection'});
        }).catch(() => {
            this.$axios.post('/onelink.mdata.main.api/web/operateTalkLater', {
            }).then((res) => {
              this.data = res.data;
              this.removeCookie('TALK_LATER_'+this.data.userId);
              this.setCookie('TALK_LATER_'+this.data.userId,this.data.instanceDay);
            });
        });
      }
      else{
        if(this.messageType == 2){
          this.$axios.post('/onelink.mdata.main.api/message/markRead', {
            id:id
          }).then((res) => {
            this.data = res.data;
            if(messageUrl.slice(0,4) == 'http'){
              window.location.href = messageUrl;
            }else{
              this.$router.push({path:'/messageNotificationDetails',query:{noticeId:id}})
            }
          }).catch((err) => {
            console.log(err)
          })
        }else{
          if(messageUrl.slice(0,4) == 'http'){
              if(message.productLine == '供应商管理'){
                window.location.href = messageUrl+message.isFinish+"&Id="+message.id;
              }else{
                if(messageUrl.indexOf("ep.fosunproperty.com")>0){
                  // let userSsoToken = Cookies.get("user_sso_token");
                  // let landedUrl = messageUrl+"&token="+userSsoToken;
                  // window.location.href= landedUrl;
                  let foSunUrl = "https://ep.fosunproperty.com:8888/";
                  let userSsoToken = Cookies.get("user_sso_token");
                  messageUrl = messageUrl.split("?")[1];
                  let guid = this.getUrlKey('guid',"?"+messageUrl)
                  let landedUrl = foSunUrl  +"Interface/YiLianAction.aspx?action=centerPage&token="+userSsoToken+"&pguid="+ this.refSysId+"&language=zh_CN";
                  window.location.href= landedUrl;
                }else if(messageUrl.indexOf("?")>0){
                  window.location.href = messageUrl+"&todoId="+message.id;
                }else{
                  window.location.href = messageUrl+"?todoId="+message.id;
                }
              }
            }else{
              this.$router.push({path:'/messageNotificationDetails',query:{noticeId:id}})
            }
        }
      }



    },
    search(productLineType,messageType){
      this.$emit('changeProductline', productLineType);
    },
    mobileClick(id,messageUrl,time,title,messageType,messageUrl2,pro){
      if(/Android|webOS|iPhone|iPad|BlackBerry/i.test(navigator.userAgent)){
        if(this.getToken('examineStatus') == '200'){
          this.$router.push({path:"registerExamine",query:{email:this.userInfo.email,companyId:this.userInfo.companyId,companyName:this.userInfo.companyName,orgIdentity:this.userInfo.orgIdentity,regAddrType:this.userInfo.regAddrType,trueName:this.userInfo.trueName}});
        }else if(this.getToken('examineStatus') == '300'){
          this.$router.push({path:"registerFailed",query:{userId:this.userInfo.id,email:this.userInfo.email,companyId:this.userInfo.companyId,companyName:this.userInfo.companyName,orgIdentity:this.userInfo.orgIdentity,regAddrType:this.userInfo.regAddrType,regeisterType:this.getToken('regeisterType'),exmaineMessage:this.getToken('exmaineMessage'),createUserId:this.userInfo.createUserId}});
        }
        else if(this.getCookie("COMPANY_COMPLETE_STATUS_"+this.getCookie("justId")) == "1"){
          this.$alert('<p>企业变更信息已提交，请耐心等待审核结果</p>', '', {
            dangerouslyUseHTMLString: true,
            customClass:'mobileText',
            center: true,
            showClose:false
          });
        }else if(this.getToken('checkFlag') == 200 && this.getCookie('TALK_LATER_'+this.getCookie('justId'))>=14){
          this.$alert('<p>请登录pc端完善企业信息</p>', '', {
            dangerouslyUseHTMLString: true,
            center: true,
            showClose:false,
            customClass:'mobileText'
          })
//          if(/Android|webOS|iPhone|iPod|BlackBerry/i.test(navigator.userAgent)) {
//            this.$alert('<p>请登录pc端完善企业信息</p>', '', {
//              dangerouslyUseHTMLString: true,
//              center: true,
//              showClose:false,
//              customClass:'mobileText'
//            })
//          } else {
//
//            this.$alert('您的企业信息不完整，无法进入项目。请立即完善企业信息', '', {
//              confirmButtonText: '立即完善企业信息',
//              center: true,
//              showClose:false,
//                customClass:'mobileText',
//              callback: action => {
//                this.$router.push({path:'/inforPerfection'});
//              }
//            });
//          }

        }
        else{
//          if(/Android|webOS|iPhone|iPad|BlackBerry/i.test(navigator.userAgent)) {
          if(messageType==2){
            this.viewMessage(id,messageUrl,time,title,messageType,pro)
          }else{
            this.viewMessage(id,messageUrl2,'','',messageType,pro)
          }
          //          this.$alert('<p>请登录pc端完善企业信息</p>', '', {
          //            dangerouslyUseHTMLString: true,
          //            center: true,
          //            showClose:false,
          //            customClass:'mobileText'
          //          })
//          } else {
//            console.log('ip')
//            return;
//          }
        }
      }else{
        console.log('ip')
        return;
      }

    },
    ieDown(){
      let url = "https://fosun-upload-prod.oss-cn-hangzhou.aliyuncs.com/%E5%A4%8D%E6%98%9F%E5%9C%B0%E4%BA%A7%E7%B1%BB%E9%A1%B9%E7%9B%AEIE%E6%B5%8F%E8%A7%88%E5%99%A8%E5%85%BC%E5%AE%B9%E6%80%A7%E8%AE%BE%E7%BD%AE.docx"
      this.$axios.get('/onelink.mdata.main.api/upload/getDownloadURL?fioleKey='+url, {
      }).then((res) => {
        window.location.href=res.data;
      }).catch((err) => {
          console.log(err)
      })
    },
    centerDialogFn(){
      this.centerDialogVisible = false;
      if(this.noMorePrompts){
        this.$axios.post('/onelink.mdata.main.api/web/todayNoMoreRemainder', {
        }).then((res) => {
          if(res.data.code == 0){
            if(/Android|webOS|iPhone|iPad|BlackBerry/i.test(navigator.userAgent)){
              this.mobileClick(this.messageId,this.messageContent,this.messageTime, this.messageTitle,
                this.messageType,this.messageUrl,this.messageInfo)
            }else{
              this.viewMessage(this.messageId,this.messageUrl,this.messageTime,this.messageTitle,
                this.messageType,this.messageInfo)
            }
          }
        }).catch((err) => {
          console.log(err)
        })
      }else{
        if(/Android|webOS|iPhone|iPad|BlackBerry/i.test(navigator.userAgent)){
          this.mobileClick(this.messageId,this.messageContent,this.messageTime, this.messageTitle,
            this.messageType,this.messageUrl,this.messageInfo)
        }else{
          this.viewMessage(this.messageId,this.messageUrl,this.messageTime,this.messageTitle,
            this.messageType,this.messageInfo)
        }
      }

    }

  }
}
</script>



// WEBPACK FOOTER //
// src/components/messageTable/index.vue